import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { useResetGovernmentAllocationDistributions } from '@/features/privateCompanies/hooks/useResetGovernmentAllocationDistributions'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ResetGovernmentAllocationDistributionModalProps {
  isOpen?: boolean
  setIsOpen: (value: boolean) => void
}

export const ResetGovernmentAllocationDistributionModal = ({
  isOpen = false,
  setIsOpen,
}: ResetGovernmentAllocationDistributionModalProps) => {
  const { id: governmentAllocationId } = useParams()
  const queryClient = useQueryClient()

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const handleZeroDistribution = () => {
    resetGovernmentAllocationDistributions()
  }

  const {
    mutate: resetGovernmentAllocationDistributions,
    isPending: resetGovernmentAllocationDistributionsIsPending,
    isError: resetGovernmentAllocationDistributionsIsError,
  } = useResetGovernmentAllocationDistributions({
    governmentAllocationId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['governmentAllocationsDistributions', governmentAllocationId] })
      queryClient.invalidateQueries({ queryKey: ['companyGovernmentAllocation', governmentAllocationId] })
      setIsOpen(false)
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base)
      } else {
        setMessages(['Erro ao zerar distribuições. Tente novamente.'])
      }
    },
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        useCancellableFooter
        confirmButtonText={
          resetGovernmentAllocationDistributionsIsPending ? 'Zerando distribuições...' : 'Zerar distribuições'
        }
        cancelButtonText="Cancelar"
        onConfirm={handleZeroDistribution}
        onCancel={() => setIsOpen(false)}
        confirmButtonIsLoading={resetGovernmentAllocationDistributionsIsPending}
        disabled={resetGovernmentAllocationDistributionsIsPending}
        bodyClassName="bg-neutral-op-8"
        body={
          <div className="text-white-800 rounded-md">
            <h1 className="text-white-800 font-bold text-2xl mb-2">Zerar distribuições?</h1>
            <p className="mb-4">Isso vai remover todos os valores distribuídos deste empenho.</p>
            <p>Até que o gestor redistribua, nenhum equipamento ou serviço poderá consumir recursos deste empenho.</p>
          </div>
        }
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={resetGovernmentAllocationDistributionsIsError}
        />
      )}
    </>
  )
}
